import { Box, Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import InfoIcon from '@mui/icons-material/Info';
import { useSelector } from 'react-redux';
import { getIsDarkModeSelector } from 'common/redux/userSettings/userSettingsSlice';
import useMobile from 'common/hooks/useMobile';
import { Dialog } from './Dialog';

type Props = {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

export const PreferredThemeDialog = ({ open, onConfirm, onClose }: Props) => {
  const isMobile = useMobile();
  const isUserThemeDarkMode = useSelector(getIsDarkModeSelector) as boolean;
  const { t } = useTranslation();
  const title = (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <InfoIcon
        sx={{
          color: 'text.secondary',
          mr: '0.75rem',
        }}
      />
      {t('changeView')}
    </Box>
  );

  const content = (
    <>
      <Box mb="1rem">
        {t('projectOptimised')} {!isUserThemeDarkMode ? 'dark' : 'light'} mode.
      </Box>
      <Box mb="1rem">{t('changeMode')}</Box>
    </>
  );
  const actions = (
    <Box
      sx={{
        display: 'flex',
        flexDirection: isMobile ? 'column-reverse' : undefined,
        width: isMobile ? '100%' : undefined,
      }}
    >
      <Button
        data-testid="popover-close-dialog"
        variant="text"
        size="large"
        onClick={onClose}
        sx={{
          height: '3rem',
          px: '2rem',
        }}
      >
        {t('NoKeep')}
      </Button>
      <Button
        data-testid="popover-delete-confirmation-button"
        variant="contained"
        color="primary"
        size="large"
        onClick={onConfirm}
        sx={{
          height: '3rem',
        }}
      >
        {t('yesChange')}
      </Button>
    </Box>
  );

  return (
    <Dialog
      content={content}
      title={title}
      open={open}
      actions={actions}
      onClose={onClose}
    />
  );
};
